export enum AlertType { 
    Success,
    Error,
    Info,
    Warning
}

export interface AlertMessage {
  id?: number;
  type: AlertType;
  text: string;
  subtext?: string;
}
